export const LEVEL_DROPDOWN_OPTIONS = [
  {
    label: 'No Level Selected',
    value: '',
  },
  {
    label: 'Special',
    value: 'special',
  },
  {
    label: 'High',
    value: 'high',
  },
  {
    label: 'Medium',
    value: 'medium',
  },
  {
    label: 'Low',
    value: 'low',
  },
  {
    label: 'Text',
    value: 'text',
  },
];
